import { HOME } from "../types/actions";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case HOME.GET_HOME_DATA:
            return { ...state, ...action.payload };
        case HOME.GET_WEIGHT_HISTORY:
            return { ...state, weight_history: action.payload }
        case HOME.GET_ADS:
            return { ...state, ads: action.payload }
        case HOME.GET_MOTIVATIONAL_VIDEOS:
            return { ...state, motivational_videos: action.payload }
        default:
            return state;
    }
};
